import { useCallback } from 'react';

import { QuizItemCache } from '../../../../api/quiz/getQuizzes/normalize/toQuizItemCache';
import { QuizOrFolder } from '../../../../api/quiz/getQuizzes/types';

export const useSelectQuizFolder = (itemIds: Set<string>) =>
  useCallback(
    (quizItemCache: QuizItemCache) =>
      [...itemIds]
        .map((itemId): QuizOrFolder => quizItemCache.itemById[itemId])
        .filter(Boolean),
    [itemIds]
  );
